// removed by extract-text-webpack-plugin
module.exports = {"appeal":"_3Cn6ZEbsCzzPYjrprznYOR"};


//////////////////
// WEBPACK FOOTER
// ./src/Appeal.css
// module id = 41
// module chunks = 0